<main class="marketplace-page py-5">
  <div class="container marketplace-container">
    <div class="marketplace-stepper d-flex flex-column flex-md-row gap-3 justify-content-between p-3 mb-4 shadow-sm">
      <div class="marketplace-step d-flex align-items-center gap-2">
        <span class="marketplace-step-number d-inline-flex align-items-center justify-content-center">1</span>
        <span>Sign in with Microsoft</span>
      </div>
      <div class="marketplace-step d-flex align-items-center gap-2">
        <span class="marketplace-step-number d-inline-flex align-items-center justify-content-center">2</span>
        <span>Confirm setup</span>
      </div>
      <div class="marketplace-step is-active d-flex align-items-center gap-2">
        <span class="marketplace-step-number d-inline-flex align-items-center justify-content-center">3</span>
        <span>Setup in progress</span>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-9 col-lg-7">
        <section class="marketplace-card card border-0 shadow-sm">
          <div class="card-body text-center p-4 p-md-5">
            <span class="marketplace-result-icon d-inline-flex align-items-center justify-content-center mb-4">
              <i class="fas fa-check"></i>
            </span>
            <p class="marketplace-eyebrow text-uppercase fw-bold mb-2">Step 3 of 3</p>
            <h1 class="h2 fw-bold mb-3">Your setup request has been received</h1>
            <p class="text-muted mb-2">Our team is preparing your AIC One environment.</p>
            <p class="text-muted mb-4">Your organisation will be ready within 24-48 hours.</p>
            <p class="text-muted mb-4">
              You will receive confirmation once your subscription has been activated and your access is ready.
            </p>

            <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
              <button type="button" class="btn marketplace-primary-btn px-4" @click="go_to_login">
                Return to login
              </button>
              <button
                v-if="can_view_dashboard"
                type="button"
                class="btn btn-outline-secondary px-4"
                @click="go_to_dashboard"
              >
                Go to dashboard
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</main>
